var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.props.tag,{tag:"component",staticClass:"event-list grid grid-gap-20",class:_vm.data.class},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }